/**
 * @generated SignedSource<<72b0a4a475c7cd3d82be9dbef7a59e3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reason"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      },
      {
        "kind": "Variable",
        "name": "versionId",
        "variableName": "versionId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "rejectReview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectReviewMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RejectReviewMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "649f075f7734dc7844551de3958bc28e",
    "id": null,
    "metadata": {},
    "name": "RejectReviewMutation",
    "operationKind": "mutation",
    "text": "mutation RejectReviewMutation(\n  $versionId: ID!\n  $reason: String!\n) {\n  rejectReview(versionId: $versionId, reason: $reason) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "c48717211900858ef42bfd9208ed2c88";

export default node;
